import escapeStringRegexp from "escape-string-regexp";

export function transliterate(text, languageCode) {

    if (replacements[languageCode]) {
        text = text.toLowerCase();

        for (const [key, value] of replacements[languageCode]) {
            text = text.replace(new RegExp(escapeStringRegexp(value), 'g'), key);
        }
    }

    return text;

}

const replacements = {
    'ar': [
        ['ث', 'th'],
        ['خ', 'kh'],
        ['ذ', 'dh'],
        ['ش', 'sh'],
        ['غ', 'gh'],
        ['ت', 't'],
        ['ء', 'e'],
        ['آ', 'a'],
        ['أ', 'a'],
        ['ؤ', 'w'],
        ['إ', 'i'],
        ['ئ', 'y'],
        ['ا', 'a'],
        ['ب', 'b'],
        ['ة', 't'],
        ['ج', 'j'],
        ['ج', 'c'],
        ['ح', 'h'],
        ['د', 'd'],
        ['ر', 'r'],
        ['ز', 'z'],
        ['س', 's'],
        ['ص', 's'],
        ['ض', 'd'],
        ['ط', 't'],
        ['ظ', 'z'],
        ['ع', 'e'],
        ['ـ', '_'],
        ['ف', 'f'],
        ['ف', 'p'],
        ['ق', 'q'],
        ['ق', 'g'],
        ['ك', 'k'],
        ['ل', 'l'],
        ['م', 'm'],
        ['ن', 'n'],
        ['ه', 'h'],
        ['و', 'w'],
        ['ى', 'a'],
        ['ي', 'y'],
        ['َ‎', 'a'],
        ['ُ', 'u'],
        ['ُ', 'o'],
        ['ِ‎', 'i'],
        ['٠', '0'],
        ['١', '1'],
        ['٢', '2'],
        ['٣', '3'],
        ['٤', '4'],
        ['٥', '5'],
        ['٦', '6'],
        ['٧', '7'],
        ['٨', '8'],
        ['٩', '9'],
    ],
    'ka': [
        ['თ', 'th'],
        ['ხ', 'kh'],
        ['დ', 'dh'],
        ['შ', 'sh'],
        ['ჩ', 'ch'],
        ['ღ', 'gh'],
        ['თ', 't'],
        ['ე', 'e'],
        ['ა', 'a'],
        ['უ', 'w'],
        ['ი', 'i'],
        ['ი', 'y'],
        ['ბ', 'b'],
        ['ჯ', 'j'],
        ['ს', 'c'],
        ['ჰ', 'h'],
        ['დ', 'd'],
        ['რ', 'r'],
        ['ზ', 'z'],
        ['ს', 's'],
        ['ე', 'e'],
        ['ფ', 'f'],
        ['პ', 'p'],
        ['ქ', 'q'],
        ['გ', 'g'],
        ['კ', 'k'],
        ['ვ', 'v'],
        ['ლ', 'l'],
        ['მ', 'm'],
        ['ნ', 'n'],
        ['ქს', 'x'],
        ['უ', 'u'],
        ['ე', 'é'],
        ['ო', 'o'],
        ['ა', 'á'],
    ]
}